import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import CompanyFields from './CompanyFields'

export const CompanyCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <CompanyFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default CompanyCreate
